import { Empty } from 'antd';

import styles from './EmptyStateMessage.module.css';

type EmptyStateMessageProps = {
  message: string | React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
};

export const EmptyStateMessage = ({ message, icon, className }: EmptyStateMessageProps) => {
  return (
    <div className={`${styles.container} ${className || ''}`}>
      <Empty image={icon || Empty.PRESENTED_IMAGE_SIMPLE} description={message} />
    </div>
  );
};
